/**
 * The SUPER_ADMIN of CXC: role SUPER_ADMIN in the STAFF entity (LEN-2764).
 *
 * identity-api's and trust-scheduler's back offices answer only this user, so the
 * shell shows Admin (SHELL_ADMIN) to nobody else. A lender's SUPER_ADMIN keeps every
 * other menu. This is presentation only: the backends enforce it.
 */
export function isStaffSuperAdmin(
  user: { role?: string; entity?: { type?: string } } | null | undefined
): boolean {
  return user?.role === 'SUPER_ADMIN' && user?.entity?.type === 'STAFF';
}
